import { AfterViewInit, EventEmitter, ChangeDetectorRef, Output, Component, OnDestroy, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { DataHelper } from '@helpers/data.helper';
import { UserHelper } from '@helpers/user.helper';
import { WebWorkerService } from '../modules/workers/web-worker.service';
import { GroupByTournamentId } from '@pipes/grouplivefixturebytournamentid';
import { LocalizationService } from '@services/localization.service';
import { SignalrServiceLegacy } from '@services/signalr.service.legacy';
import { OddComboModel } from './sports.component';
import { environment } from '@environments/environment';
import { ApiService } from '@services/api.service';
@Component({
  selector: 'live-single-eventlist',
  templateUrl: '../sharedTemplates/live-single-eventlist.html',
})
export class LiveSingleEventList implements OnInit, AfterViewInit, OnDestroy {
  liveMatchList = [];
  oldLiveMatchList = [];
  cardList = [];

  _fixtureUpcoming;

  liveSubscription;
  liveFilterSubscription;
  liveCardSubscription;
  liveMatchobservable = new BehaviorSubject<any>([]);
  _liveFilterItems;

  matchFilterBySportKey = '';

  oddLiveMarketingB3000Value = [0]; // B3000
  oddLiveMarketingValue = [0, 9, 8];

  __ResultLiveData;
  __ResultLiveFavsData;
  isInitialized = false;

  _GroupByTournamentId = new GroupByTournamentId();

  oddTypeArray = [];
  _oddTypes = this._DataHelper.oddTypes;
  oddDatas = [];
  mLine = [false];

  fullmatch: Observable<any[]>;

  @Input() _sportName;
  @Input() _selectedOdds = [];
  @Output() addOdd = new EventEmitter();

  oddComboList: Array<OddComboModel> = [
    { OddId: 0, OddNameLong: 'tipp_long', OddName: 'tipp', OddTitles: ['1', 'X', '2'] },
    { OddId: 9, OddNameLong: 'RoM', OddName: 'RoM', OddTitles: ['1', 'X', '2'] },
    { OddId: 10, OddNameLong: 'O/U_long', OddName: 'O/U', OddTitles: ['+', '', '-'] },
    { OddId: 11, OddNameLong: '1x2 HT', OddName: '1x2 HT', OddTitles: ['1', 'X', '2'] },
    { OddId: 12, OddNameLong: 'NextGoal', OddName: 'NT', OddTitles: ['1', 'X', '2'] },
    { OddId: 13, OddNameLong: 'RoM HT', OddName: 'RoM HT', OddTitles: ['1', 'X', '2'] },
    { OddId: 14, OddNameLong: 'Ü/U 1.HZ_long', OddName: 'Ü/U 1.HZ', OddTitles: ['+', '', '-'] },
  ];
  combo1SelectedOdd = this.oddComboList.find(combo => combo.OddId == 0);

  constructor(
    private _SignalRService: SignalrServiceLegacy,
    public _DataHelper: DataHelper,
    private cdRef: ChangeDetectorRef,
    private _LocalizationService: LocalizationService,
    private _webWorkerService: WebWorkerService,
    private _UserHelper: UserHelper,
    private _router: Router,
    private _ApiService: ApiService
  ) {}

  ngOnInit() {
    this.oddTypeArray = this.oddLiveMarketingB3000Value;
    this.init();
  }

  init() {
    this.oddTypeArray.forEach(_y => {
      if (Object.prototype.hasOwnProperty.call(this._oddTypes[_y], this._sportName)) {
        this.oddDatas[_y] = this._oddTypes[_y][this._sportName];
      } else {
        this.oddDatas[_y] = this._oddTypes[_y]['all'];
      }

      // ////console.log('init', this.oddDatas[_y][0]);
      if (this.oddDatas[_y][0]['set'] != null) {
        if (this.oddDatas[_y][0]['set']['mLine'] != null) {
          if (this.oddDatas[_y][0]['set']['mLine'] === true) {
            this.mLine[_y] = true;
            this.oddDatas[_y] = this.reBuilderData(this.oddDatas[_y]);
          }
        } else {
          this.mLine[_y] = false;
        }
      }
    });
  }

  reBuilderData(x) {
    const a = [];
    let curLine = 1;
    let lines = [];
    x.forEach(y => {
      if (curLine === y.line) {
        lines.push(y);
      } else {
        lines = [];
        lines.push(y);
        curLine = y.line;
      }
      lines = lines.map(s => {
        // ////console.log(s);

        // s['lineText'] = lines[0]['type'];
        return s;
      });
      a[y.line] = lines;
    });
    return a.splice(1);

    //  ////console.log(this.oddDatas, this.oddTypeArray);
  }

  ngAfterViewInit() {
    if (!this._SignalRService.connectionExists) {
      this._SignalRService.connectionEstablished.subscribe(x => {
        //console.log("canlı bağlandı detayda : ", x);
        this.connectHub();
      });
    } else {
      this.connectHub();
    }
  }

  connectHub() {
    try {
      if (this.liveSubscription != undefined) {
        this.liveSubscription.unsubscribe();
      }
      if (this.liveFilterSubscription != undefined) {
        this.liveFilterSubscription.unsubscribe();
      }
      if (this.liveCardSubscription != undefined) {
        this.liveCardSubscription.unsubscribe();
      }
    } catch (e) {
      console.log(e);
    }

    this.liveSubscription = this._DataHelper.liveDataListener.subscribe(y => {
      this.oldLiveMatchList = this.liveMatchList;
      this.liveMatchList = y;
      if (this._fixtureUpcoming != undefined) {
        this.liveMatchList.push(...this._fixtureUpcoming);
      }

      this.liveMatchobservable.next(this.liveMatchList);

      this.dataRebuild();
    });

    this.liveMatchobservable.next(this._DataHelper.liveData);
    this.liveMatchList = this._DataHelper.liveData;
    this.oldLiveMatchList = this.liveMatchList;

    this.cardList = this._DataHelper.cardData;

    this.liveCardSubscription = this._DataHelper.cardDataListener.subscribe(y => {
      this.cardList = y;
    });

    this._liveFilterItems = this._DataHelper.liveFilterItems;
    this.liveFilterSubscription = this._DataHelper.liveFilterItemsListener.subscribe((x: any) => {
      const leagueFilteredData = JSON.parse(localStorage.getItem('league-filter-data'));
      if (x == null || (x.length == 0 && leagueFilteredData != null && leagueFilteredData.length > 0)) {
        this._liveFilterItems = leagueFilteredData;
        this._DataHelper.liveFilterItems = leagueFilteredData;
      } else {
        this._liveFilterItems = x;
        this._DataHelper.liveFilterItems = x;
      }

      this.dataRebuild();
    });

    this.dataRebuild();

    this.cdRef.detectChanges();

    this._SignalRService.readUpdatedEvents();
  }

  dataRebuild() {
    const wwsConfig = {
      langCode: this._LocalizationService.LANGCODE,
      lml: this.liveMatchList,
      old_lml: this.oldLiveMatchList,
      mfbysk: this.matchFilterBySportKey,
      lfi: this._liveFilterItems,
      cardList: this.cardList,
      oddtype: this.oddLiveMarketingValue,
      favorable: this._UserHelper.favoriedMatches,
      isLive: true,
      liveSortbyTime: this._DataHelper.liveSortbyTime,
      liveFavoriteButtonStatus: this._DataHelper.getFavoritesButtonStatus(),
      liveFavoriteData: this._DataHelper.getLiveFavoriteTournamentData(),
    };

    if (this.liveMatchList === undefined) {
      return;
    }

    const promise = this._webWorkerService
      .run(this._DataHelper.webWorkerLiveJob, wwsConfig)
      .then(result => {
        this.__ResultLiveData = result.dt;

        const Obsobj = of(this.__ResultLiveData);
        this.fullmatch = Obsobj;
        // League Filter
        this._DataHelper.setLiveEventRebuildedUnfiltered(this._GroupByTournamentId.transform(result.dtUn, null));

        this._DataHelper.setLiveGoalListData(result.liveGoalListData);

        //////console.log('checkThis', result);
        // League Filter
        this.isInitialized = true;
        // Fav Data
        this.__ResultLiveFavsData = result.dtFavs;
        this.cdRef.detectChanges();
      })
      .catch(e => {
        //console.error(e)
      });
  }

  oddComboChange(oddMarket, index) {
    console.log(oddMarket);
    console.log(this.oddTypeArray);
    this.oddTypeArray[0] = oddMarket.OddId;
    this.init();
    // // Favorable states Updates
    // const x = this.getFavorableStates(this.preMatchList);
    // this.preMatchList = x;
    // this.preMatchobservable.next(this.preMatchList);
  }

  goEventDetail2(e, f, g) {
    // //console.log('DD-G',g);
    // //console.log('DD-E',e);
    // //console.log('DD-F',f);
    // //console.log('DD-EVENT_DETAIL',g.HasStreaming,e,f);
    this._DataHelper.selectedMatch = g;

    if (g == null) {
      this._router.navigate(['/eventdetail', e == null ? f : e]);
    } else if (g.HasStreaming == null || g.HasStreaming == 'pre' || g.HasStreaming == false) {
      this._router.navigate(['/eventdetail', e == null ? f : e]);
    } else {
      this._router.navigate(['/liveeventdetail', e == null ? f : e]);
    }
  }

  ngOnDestroy() {
    this._DataHelper.setLiveGoalListData([]);

    // Favourites Button Status Clean
    this._DataHelper.setFavoritesButtonStatus(false);

    // League Filter Clean ( Local Storage )
    localStorage.setItem('league-filter-data', JSON.stringify([]));

    try {
      if (this.liveSubscription != undefined) {
        this.liveSubscription.unsubscribe();
      }
      if (this.liveFilterSubscription != undefined) {
        this.liveFilterSubscription.unsubscribe();
      }
      if (this.liveCardSubscription != undefined) {
        this.liveCardSubscription.unsubscribe();
      }
    } catch (e) {
      console.log(e);
    }
  }

  checkOddId(oddId) {
    const index = this._ApiService.slipCurrents.findIndex(v => {
      return v.OddId1 == oddId;
    });
    if (index > -1) {
      return 'active';
    } else {
      return '';
    }
  }

  clickOddUP(_oddId, isActive?) {
    // //console.log('--environment.submitBetModifyControl--',environment.submitBetModifyControl);
    if (!this._DataHelper.ChangeOddIsActive && environment.submitBetModifyControl) return '';

    const newodd = {
      OddId: _oddId,
    };

    const index = this._ApiService.slipCurrents.findIndex(v => {
      return v.OddId1 == _oddId;
    });

    if (isActive != null) {
      if (isActive) {
        this._ApiService.addLiveOdd(_oddId);
      }
    } else {
      this._ApiService.addLiveOdd(_oddId);
    }
  }
}
